import { render, staticRenderFns } from "./radarChart.vue?vue&type=template&id=5f0131da"
import script from "./radarChart.vue?vue&type=script&lang=js"
export * from "./radarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0131da')) {
      api.createRecord('5f0131da', component.options)
    } else {
      api.reload('5f0131da', component.options)
    }
    module.hot.accept("./radarChart.vue?vue&type=template&id=5f0131da", function () {
      api.rerender('5f0131da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/echarts/other/components/radarChart.vue"
export default component.exports